<template>
  <div class="success-content">
    <!-- 这里需要是因为resultData为空可能会报错 -->
    <div v-if="resultData && Object.keys(resultData).length > 0">
      <!-- 根据实际接口返回的数据结构展示结果 -->
      <div class="result-item" v-if="resultData.version">
        <span class="result-label">本次升级车辆版本：</span>
        <span class="result-value">{{ resultData.version }}</span>
      </div>
      <div class="result-item" v-if="resultData.begin_date_new">
        <span class="result-value">{{ `${resultData.begin_date_new}开始陆续推送` }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VinSuccessContent',
  props: {
    resultData: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped lang="less">
.success-content {
  width: 100%;

  .result-item {
    display: flex;
    align-items: center;
    .px2rem(margin-bottom, 8);
    .px2rem(font-size, 12);
    font-weight: 400;
    .px2rem(line-height, 18);
    &:last-child {
      margin-bottom: 0;
    }
  }

  .result-label {
    color: #5C606A;
  }

  .result-value {
    color:#1A1D25;
  }

}
</style>